import React from "react";
import { EdSupportPageImg } from "../../assets";

const EdSupportTab = () => {
  return (
    <div className="">
      <div className="px-6 md:px-12 border-2 m-4 border-black rounded py-4 lg:py-8">
        
        {/* Title */}
        <div className="font-Cheri text-center text-secondaryBg text-4xl font-bold md:text-6xl mb-6 md:mb-8 lg:mb-10">
          Seekh.
        </div>

        {/* Content Row */}
        <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-10">
          
          {/* Image - sticks to top left on md+ */}
          <div className="md:w-1/2 md:sticky md:top-4 self-start flex-shrink-0">
            <img
              src={EdSupportPageImg}
              alt="Ed Support"
              className="w-full rounded-lg object-cover"
            />
          </div>

          {/* Scrollable Text Content */}
          <div className="md:w-1/2 md:max-h-[70vh] md:overflow-y-auto pr-1 font-Poppins text-justify space-y-5 lg:text-xl lg:leading-9 text-gray-800">
            
            <p>
              Every child deserves the chance to dream, but for many underprivileged children, the end of the school day often means the end of their learning. That is where our{" "}
              <span className="font-semibold text-secondaryBg">Seekh initiative</span>{" "}
              steps in.
            </p>

            <p>
              Operating across our Bhavishya NGO centres in{" "}
              <span className="font-medium">
                Uttar Pradesh, West Bengal, Bihar, Karnataka, Haryana, Delhi, and Maharashtra
              </span>
              , Seekh is much more than an after-school support program — it is a safe haven for curiosity, creativity, and growth.
            </p>

            <p>
              We believe that true education goes far beyond textbooks. Through Seekh, we nurture the whole child, blending essential academic guidance with the joy of holistic development. In our centres, classrooms come alive with the vibrant colors of{" "}
              <span className="font-medium">drawing sessions</span>, the calm focus of{" "}
              <span className="font-medium">yoga</span>, and the energy of{" "}
              <span className="font-medium">interactive skill-building</span>.
            </p>

            <p>
              We equip children with vital life skills while ensuring they never lose out on the simple, transformative power of fun. It is a space where confidence is built, one afternoon at a time.
            </p>

            <div className="bg-secondaryBg/10 border-l-4 border-secondaryBg rounded-r-lg px-4 py-3">
              <p className="font-semibold text-secondaryBg text-lg lg:text-2xl">
                10,000+ children empowered
              </p>
              <p className="text-sm lg:text-base text-gray-600 mt-1">
                Each representing a brighter future, a broken cycle of poverty, and a beautiful story waiting to be written.
              </p>
            </div>

            <p>
              With Seekh, we aren't just teaching children — we are giving them the tools and the belief to{" "}
              <span className="font-semibold">shape their own destinies</span>.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default EdSupportTab;